module.exports = "::ng-deep .ng-select div {\n  margin-right: 0; }\n"